
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import { Modal, Segmented, Row, Col, AutoComplete, Button, List, Checkbox } from 'antd';
import GoogleMap from "google-map-react";
import { googleMapsStyle } from "../../../../helpers";
import Marker from '../../components/GoogleMaps/Marker';

const { Option } = AutoComplete;
let searchTimeout = null;
let mapsTimeout = null;

function createMapOptions(maps) {
    return {
        zoomControlOptions: {
            position: maps.ControlPosition.RIGHT_CENTER,
            style: maps.ZoomControlStyle.SMALL
        },
        mapTypeControlOptions: { position: maps.ControlPosition.TOP_RIGHT },
        styles: googleMapsStyle,
        mapTypeControl: true,
        scrollwheel: false
    };
}


class TripEditWhereAddress extends Component {

    constructor(props) {
        super(props);
        this.state = {
            segmentType: "search",
            loadings: {
                map: false,
                search: false
            },
            form: {
                type: props.type,
                latitude: props.selectedRoute ? props.selectedRoute.latitude : null,
                longitude: props.selectedRoute ? props.selectedRoute.longitude : null,
                address: props.selectedRoute ? props.selectedRoute.address : null
            },
            selectedAddress: null,
            values: {
                searchLocations: []
            },
            googleMapsRefresh: false
        };
        this.formRef = React.createRef();
        this.initMap = this.initMap.bind(this);
    }

    componentDidMount() {

    }

    componentWillMount() {

        if (this.props.account.mapsClient === "Yandex") {
            try {
                this.map.destroy();
                this.map = null;
            } catch (e) {
            }

            this.ymap = window.ymaps;

            setTimeout(() => {
                this.ymap.ready(this.initMap);
            }, 500);
        }

    }

    initMap() {

        let _this = this;

        var coordinates = [41.045930450756735, 29.033413529100827];
        let { form } = this.state;

        if (form.latitude) {
            coordinates = [form.latitude, form.longitude]
        }

        this.map = new this.ymap.Map('map-yandex', {
            center: coordinates,
            zoom: 13,
            controls: ['fullscreenControl']
        }, {
            buttonMaxWidth: 300,
            top: 100,
            left: 10
        });

        var zoomControl = new this.ymap.control.ZoomControl({
            options: {
                size: "small"
            }

        });

        this.map.controls.add(zoomControl);

        var fullscreenControl = new this.ymap.control.FullscreenControl({
            options: {
                right: 50,
                bottom: 50,
                width: 26,
                height: 25
            }

        });

        this.map.controls.add(fullscreenControl);

        var placemark = null;

        placemark = new this.ymap.Placemark(coordinates, {
            iconCaption: ''
        }, {
            preset: 'islands#violetDotIconWithCaption',
            draggable: true,
            iconColor: '#32a852'
        });

        this.map.geoObjects.add(placemark);

        placemark.events.add('dragend', function (e) {

            var coordinates = e.originalEvent.target.geometry._coordinates;
            _this.onSelectAddress(`${coordinates[0]}|${coordinates[1]}`);

        }).add('submit', function () {
        });

        setTimeout(() => {
            placemark.geometry.setCoordinates(coordinates)
            this.map.setCenter(coordinates, 13);
        }, 1000);
    }

    addressSearchQuery = (query) => {

        let { values } = this.state;

        if (query.length <= 2) {
            return;
        }

        if (query === null || query === '' || query === undefined) {
            values.searchLocations = [];
            this.setState({ values });
            return;
        }


        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {

            let { loadings } = this.state;
            loadings.search = true;
            this.setState({ loadings })

            let endpoint = { keyOne: `googlemaps/autocomplete?keyword=${query}` };
            this.props
                .dispatch(
                    actions.definitions.getDatas({
                        ...endpoint,
                    })
                )
                .then((response) => {
                    values.searchLocations = response;
                    loadings.search = false;
                    this.setState({ values, loadings });
                });
        }, 500);
    };

    onSelectAddress = (value, option) => {

        const coordinates = value.split('|');

        let { form, loadings } = this.state;
        loadings.search = true;
        form.latitude = coordinates[0];
        form.longitude = coordinates[1];

        this.setState({ loadings, form });

        let endpoint = { keyOne: `googlemaps/placedetailbylocation?latitude=${coordinates[0]}&longitude=${coordinates[1]}` };

        if (this.props.account.mapsClient === "Google") {
            endpoint = { keyOne: `googlemaps/placedetailbyId?placeId=${coordinates[0]}` };
        }

        this.props
            .dispatch(
                actions.definitions.getDatas({
                    ...endpoint,
                })
            )
            .then((response) => {

                if (this.props.account.mapsClient === "Google") {
                    this.onPlaceDetailByLocation(response.latitude, response.longitude)
                } else {
                    setTimeout(() => {
                        form.address = response.address;
                        form.latitude = coordinates[0];
                        form.longitude = coordinates[1];
                        loadings.search = false;
                        this.setState({ form, loadings }, () => {
                            this.refreshMap();
                        });
                    })
                }


            });

    }

    onPlaceDetailByLocation = (latitude, longitude) => {

        clearTimeout(mapsTimeout);
        mapsTimeout = setTimeout(() => {

            let { form, loadings } = this.state;
            loadings.search = true;


            form.latitude = latitude;
            form.longitude = longitude;

            this.setState({ loadings, form });

            let endpoint = { keyOne: `googlemaps/placedetailbylocation?latitude=${latitude}&longitude=${longitude}` };

            this.props
                .dispatch(
                    actions.definitions.getDatas({
                        ...endpoint,
                    })
                )
                .then((response) => {

                    setTimeout(() => {
                        form.address = response.address;
                        form.latitude = latitude;
                        form.longitude = longitude;
                        loadings.search = false;
                        this.setState({ loadings, form }, () => {
                            this.refreshMap()
                        })
                    })
                });

        }, 500)

    }

    onChangeInput = (data, option) => {


        let { form } = this.state;
        form.address = option.children
        this.setState({ form });

    };


    refreshMap = () => {

        if (this.props.account.mapsClient === "Yandex") {
            let { loadings } = this.state;
            loadings.map = true;

            this.setState({ loadings }, () => {
                setTimeout(() => {
                    try {
                        this.map.destroy();
                        this.map = null;
                    } catch (e) {
                    }

                    this.ymap.ready(this.initMap);
                    loadings.map = false;
                    this.setState({ loadings })
                }, 100);
            })
        } else {
            this.setState({ googleMapsRefresh: true })
            setTimeout(() => {
                this.setState({ googleMapsRefresh: false })
            }, 100);
        }


    }

    onChangeSegmented = (value) => {
        this.setState({ segmentType: value })
        if (value === "search") {
            this.refreshMap()
        }
    }

    onSelectMyAddress = (item) => {

        let { form } = this.state;

        form.address = item.address;
        form.latitude = item.latitude;
        form.longitude = item.longitude;

        this.setState({ form, selectedAddress: item }, () => {
            this.refreshMap();
        });

    }

    onSave = () => {

        this.props.addRoute(this.state.form, this.props.selectedIndex);
        this.props.handleToggle();

    }


    render() {

        let { isModalAddress, handleToggle, addresses } = this.props;
        let { segmentType, values, loadings, form, selectedAddress } = this.state;


        if (!form.latitude && !form.longitude) {
            form["latitude"] = 41.045930450756735
            form["longitude"] = 29.033413529100827;
        }

        return (
            <Modal
                className='trip-address-modal'
                title="Adres Seç" centered open={isModalAddress} onOk={handleToggle} onCancel={handleToggle}
                maskClosable={false}
                footer={null}
                destroyOnClose={true}
                width={760}
                height={540}

            >
                <Segmented block options={
                    [
                        {
                            value: "search",
                            label: "ADRES ARAT"
                        },
                        {
                            value: "myaddress",
                            label: "ADRESLERİM"
                        }
                    ]
                }
                    onChange={(e) => this.onChangeSegmented(e)}
                    value={segmentType}
                />

                {
                    segmentType === "search" &&
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <div className='maps-container'>
                                {
                                    this.props.account.mapsClient === "Yandex" ?
                                        <div id="map-yandex" className="map" style={{ width: "%100", height: 400 }} />
                                        :

                                        <Fragment>

                                            <GoogleMap
                                                bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
                                                onChange={(e) => this.onPlaceDetailByLocation(e.center.lat, e.center.lng)}
                                                center={[form.latitude, form.longitude]}
                                                yesIWantToUseGoogleMapApiInternals={true}
                                                zoom={12}
                                                style={{ width: 1250, height: 350 }}
                                                options={createMapOptions}
                                                draggable={true}
                                            />

                                            <Marker
                                                key={"startMap-"}
                                                claz="start-point"
                                                lat={form.latitude}
                                                lng={form.longitude}
                                            />

                                        </Fragment>
                                        // <Map data={form}
                                        //     onChangeMap={this.onPlaceDetailByLocation}
                                        ///>
                                }

                                <AutoComplete
                                    ref={this.searchInputRef}
                                    value={form.address}
                                    dropdownMatchSelectWidth={252}
                                    onSelect={(val, option) => this.onSelectAddress(val, option)}
                                    onSearch={this.addressSearchQuery}
                                    onChange={this.onChangeInput}
                                    loading={loadings.search}
                                    showSearch
                                    placeholder={`${i18n.t("Adresi buraya yazarak aratabilirsiniz", {
                                        lng: this.props.currentLanguage,
                                    })}`}
                                >
                                    {values.searchLocations.map((searchLocation) => (
                                        <Option key={searchLocation.placeId} value={searchLocation.placeId}>
                                            {searchLocation.address}
                                        </Option>
                                    ))}
                                </AutoComplete>

                                {
                                    form.address &&
                                    <div className='selected-address'>
                                        <div className='label'>İŞARETLENEN ADRES</div>
                                        <div className='address'>{form.address}</div>
                                        <Button
                                            type={'primary'}
                                            onClick={() => this.onSave()}
                                        >Tamam</Button>
                                    </div>
                                }
                            </div>
                        </Col>
                    </Row>
                }

                {
                    segmentType === "myaddress" &&
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <div className='address-container'>
                                <List
                                    dataSource={addresses}
                                    renderItem={(item) => (
                                        <List.Item key={item.id}
                                            onClick={() => this.onSelectMyAddress(item)}
                                        >
                                            <List.Item.Meta
                                                avatar={<Checkbox checked={selectedAddress && selectedAddress.id === item.id}></Checkbox>}
                                                title={item.name}
                                                description={item.address}
                                            />
                                        </List.Item>
                                    )}
                                />

                                {
                                    selectedAddress && form.address &&
                                    <div className='selected-address'>
                                        <Button
                                            type={'primary'}
                                            onClick={() => this.onSave()}
                                        >Tamam</Button>
                                    </div>
                                }
                            </div>
                        </Col>
                    </Row>
                }

            </Modal>
        );
    }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default connect(mapStateToProps)(TripEditWhereAddress);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripEditWhereAddress.js